// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
}

.featured-page {
  padding: 2px 0 8px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  margin-bottom: 18px;
}

.page-header h1 {
  margin: 0;
  color: #172b46;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
}

.page-header p {
  margin: 6px 0 0;
  color: #7d8a9d;
  font-size: 12px;
}

.header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 35px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  padding: 7px 12px;
  background: #fff;
  color: #53647a;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.button .material-symbols-outlined {
  font-size: 18px;
}

.button.primary {
  border-color: var(--primary-color);
  background: var(--primary-color);
  color: #fff;
}

.button.secondary:hover,
.button.secondary.selected {
  border-color: color-mix(in srgb, var(--primary-color) 25%, white);
  background: color-mix(in srgb, var(--primary-color) 5%, white);
  color: var(--primary-color);
}

.filter-wrapper {
  position: relative;
}

.filter-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--primary-color);
}

.filter-dropdown {
  position: absolute;
  z-index: 20;
  inset-inline-end: 0;
  top: calc(100% + 10px);
  width: 340px;
  max-width: calc(100vw - 48px);
  box-sizing: border-box;
  padding: 18px;
  border: 1px solid #dce5ef;
  border-radius: 12px;
  box-shadow: 0 10px 35px rgba(23, 43, 70, 0.13);
  background: #fff;
}

.filter-heading h2 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}

.filter-heading p {
  margin: 4px 0 14px;
  font-size: 11px;
}

.filter-label {
  display: block;
  margin: 12px 0 6px;
  color: #53647a;
  font-size: 11px;
  font-weight: 500;
}

.filter-dropdown mat-form-field {
  width: 100%;
  font-size: 11px;
  --mat-form-field-container-height: 36px;
  --mat-form-field-container-vertical-padding: 8px;
  --mdc-outlined-text-field-outline-color: #dce5ef;
  --mdc-outlined-text-field-focus-outline-color: var(--primary-color) ;
}

.filter-search {
  position: relative;
}

.filter-search > span {
  position: absolute;
  z-index: 1;
  inset-inline-start: 10px;
  top: 9px;
  color: #8a98ab;
  font-size: 17px;
}

.filter-search input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  padding: 0 10px 0 33px;
  font: inherit;
  font-size: 11px;
}

.date-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.date-fields > div,
.date-fields mat-form-field {
  min-width: 0;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #edf1f6;
}

.table-card {
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.table-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  border-bottom: 1px solid #edf1f6;
}

.table-heading h2 {
  display: flex;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}

.table-heading h2 span {
  padding: 1px 6px;
  border-radius: 5px;
  background: #f1f6fd;
  color: #6480a4;
  font-size: 10px;
}

.text-button {
  border: 0;
  background: transparent;
  color: var(--primary-color);
  font: inherit;
  font-size: 11px;
  cursor: pointer;
}

.table-scroll {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: start;
  font-size: 11px;
}

th {
  padding: 12px 16px;
  background: #fbfcfe;
  color: #7d8a9d;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}

td {
  padding: 12px 16px;
  border-top: 1px solid #edf1f6;
  color: #53647a;
  vertical-align: middle;
}

tbody tr:hover {
  background: #fcfdff;
}

.sort-button {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.sort-button:hover {
  color: var(--primary-color);
}

.sort-button span {
  font-size: 15px;
}

.product-code {
  color: var(--primary-color);
  font-weight: 500;
}

.product-image {
  display: block;
  width: 36px;
  height: 36px;
  border: 1px solid #edf1f6;
  border-radius: 7px;
  object-fit: contain;
}

.truncate {
  display: block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  padding: 3px 7px;
  background: #f1f3f7;
  color: #7d8a9d;
  white-space: nowrap;
}

.status > span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}

.status.approved {
  background: #eef7f2;
  color: #36866a;
}

.status.rejected {
  background: #fff0f0;
  color: #c34242;
}

.status.pending {
  background: #fff7e6;
  color: #936300;
}

.actions-column {
  text-align: center;
  width: 50px;
}

.row-menu-button {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #8491a3;
  cursor: pointer;
}

.row-menu-button:hover {
  background: color-mix(in srgb, var(--primary-color) 9%, white);
  color: var(--primary-color);
}

.action-icon {
  margin-inline-end: 10px;
  color: #8491a3;
  font-size: 18px;
}

.skeleton-row td {
  height: 43px;
}

.table-skeleton {
  display: block;
  min-width: 55px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);
  background-size: 400% 100%;
  animation: featured-skeleton 1.35s ease infinite;
}

@keyframes featured-skeleton {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
.empty-state {
  text-align: center;
  padding: 50px;
  color: #8491a3;
}

.empty-state span {
  font-size: 28px;
}

@media (max-width: 750px) {
  .page-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .header-actions {
    width: 100%;
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/featured-product-management/featured-product-management.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,kCAAA;EACA,gCAAA;EACA,WAAA;AACJ;;AAEA;;EAEI,iEAAA;EACA,8DAAA;EACA,2BAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;AACJ;;AAEA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,oEAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,gDAAA;EACA,SAAA;AACJ;;AAEA;;EAEI,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AACJ;;AAEA;EACI,aAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,sBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,2BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,8DAAA;EACA,2BAAA;AACJ;;AAEA;EACI,uBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,gDAAA;AACJ;;AAEA;EACI;IACI,2BAAA;EACN;EAEE;IACI,wBAAA;EAAN;AACF;AAGA;EACI,kBAAA;EACA,aAAA;EACA,cAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI;IACI,uBAAA;IACA,sBAAA;EADN;EAIE;IACI,WAAA;IACA,eAAA;EAFN;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px\n}\n\n.featured-page {\n    padding: 2px 0 8px\n}\n\n.page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 18px;\n    margin-bottom: 18px\n}\n\n.page-header h1 {\n    margin: 0;\n    color: #172b46;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 30px\n}\n\n.page-header p {\n    margin: 6px 0 0;\n    color: #7d8a9d;\n    font-size: 12px\n}\n\n.header-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center\n}\n\n.button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    min-height: 35px;\n    border: 1px solid #dce5ef;\n    border-radius: 8px;\n    padding: 7px 12px;\n    background: #fff;\n    color: #53647a;\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer\n}\n\n.button .material-symbols-outlined {\n    font-size: 18px\n}\n\n.button.primary {\n    border-color: var(--primary-color);\n    background: var(--primary-color);\n    color: #fff\n}\n\n.button.secondary:hover,\n.button.secondary.selected {\n    border-color: color-mix(in srgb, var(--primary-color) 25%, white);\n    background: color-mix(in srgb, var(--primary-color) 5%, white);\n    color: var(--primary-color)\n}\n\n.filter-wrapper {\n    position: relative\n}\n\n.filter-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--primary-color)\n}\n\n.filter-dropdown {\n    position: absolute;\n    z-index: 20;\n    inset-inline-end: 0;\n    top: calc(100% + 10px);\n    width: 340px;\n    max-width: calc(100vw - 48px);\n    box-sizing: border-box;\n    padding: 18px;\n    border: 1px solid #dce5ef;\n    border-radius: 12px;\n    box-shadow: 0 10px 35px rgba(23, 43, 70, .13);\n    background: #fff\n}\n\n.filter-heading h2 {\n    margin: 0;\n    font-size: 13px;\n    font-weight: 600\n}\n\n.filter-heading p {\n    margin: 4px 0 14px;\n    font-size: 11px\n}\n\n.filter-label {\n    display: block;\n    margin: 12px 0 6px;\n    color: #53647a;\n    font-size: 11px;\n    font-weight: 500\n}\n\n.filter-dropdown mat-form-field {\n    width: 100%;\n    font-size: 11px;\n    --mat-form-field-container-height: 36px;\n    --mat-form-field-container-vertical-padding: 8px;\n    --mdc-outlined-text-field-outline-color: #dce5ef;\n    --mdc-outlined-text-field-focus-outline-color: var(--primary-color)\n}\n\n.filter-search {\n    position: relative\n}\n\n.filter-search>span {\n    position: absolute;\n    z-index: 1;\n    inset-inline-start: 10px;\n    top: 9px;\n    color: #8a98ab;\n    font-size: 17px\n}\n\n.filter-search input {\n    width: 100%;\n    height: 36px;\n    box-sizing: border-box;\n    border: 1px solid #dce5ef;\n    border-radius: 7px;\n    padding: 0 10px 0 33px;\n    font: inherit;\n    font-size: 11px\n}\n\n.date-fields {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px\n}\n\n.date-fields>div,\n.date-fields mat-form-field {\n    min-width: 0\n}\n\n.filter-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 18px;\n    padding-top: 14px;\n    border-top: 1px solid #edf1f6\n}\n\n.table-card {\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff;\n    overflow: hidden\n}\n\n.table-heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 18px;\n    border-bottom: 1px solid #edf1f6\n}\n\n.table-heading h2 {\n    display: flex;\n    gap: 8px;\n    margin: 0;\n    font-size: 13px;\n    font-weight: 600\n}\n\n.table-heading h2 span {\n    padding: 1px 6px;\n    border-radius: 5px;\n    background: #f1f6fd;\n    color: #6480a4;\n    font-size: 10px\n}\n\n.text-button {\n    border: 0;\n    background: transparent;\n    color: var(--primary-color);\n    font: inherit;\n    font-size: 11px;\n    cursor: pointer\n}\n\n.table-scroll {\n    overflow-x: auto\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: start;\n    font-size: 11px\n}\n\nth {\n    padding: 12px 16px;\n    background: #fbfcfe;\n    color: #7d8a9d;\n    font-size: 10px;\n    font-weight: 500;\n    white-space: nowrap\n}\n\ntd {\n    padding: 12px 16px;\n    border-top: 1px solid #edf1f6;\n    color: #53647a;\n    vertical-align: middle\n}\n\ntbody tr:hover {\n    background: #fcfdff\n}\n\n.sort-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    cursor: pointer\n}\n\n.sort-button:hover {\n    color: var(--primary-color)\n}\n\n.sort-button span {\n    font-size: 15px\n}\n\n.product-code {\n    color: var(--primary-color);\n    font-weight: 500\n}\n\n.product-image {\n    display: block;\n    width: 36px;\n    height: 36px;\n    border: 1px solid #edf1f6;\n    border-radius: 7px;\n    object-fit: contain\n}\n\n.truncate {\n    display: block;\n    max-width: 180px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.status {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    border-radius: 20px;\n    padding: 3px 7px;\n    background: #f1f3f7;\n    color: #7d8a9d;\n    white-space: nowrap\n}\n\n.status>span {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: currentColor\n}\n\n.status.approved {\n    background: #eef7f2;\n    color: #36866a\n}\n\n.status.rejected {\n    background: #fff0f0;\n    color: #c34242\n}\n\n.status.pending {\n    background: #fff7e6;\n    color: #936300\n}\n\n.actions-column {\n    text-align: center;\n    width: 50px\n}\n\n.row-menu-button {\n    display: inline-grid;\n    place-items: center;\n    width: 28px;\n    height: 28px;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: #8491a3;\n    cursor: pointer\n}\n\n.row-menu-button:hover {\n    background: color-mix(in srgb, var(--primary-color) 9%, white);\n    color: var(--primary-color)\n}\n\n.action-icon {\n    margin-inline-end: 10px;\n    color: #8491a3;\n    font-size: 18px\n}\n\n.skeleton-row td {\n    height: 43px\n}\n\n.table-skeleton {\n    display: block;\n    min-width: 55px;\n    height: 12px;\n    border-radius: 4px;\n    background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);\n    background-size: 400% 100%;\n    animation: featured-skeleton 1.35s ease infinite\n}\n\n@keyframes featured-skeleton {\n    0% {\n        background-position: 100% 0\n    }\n\n    100% {\n        background-position: 0 0\n    }\n}\n\n.empty-state {\n    text-align: center;\n    padding: 50px;\n    color: #8491a3\n}\n\n.empty-state span {\n    font-size: 28px\n}\n\n@media(max-width:750px) {\n    .page-header {\n        align-items: flex-start;\n        flex-direction: column\n    }\n\n    .header-actions {\n        width: 100%;\n        flex-wrap: wrap\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
